import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedComponentsModule } from './components/shared-components.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { MatInputModule } from '@angular/material/input';
import { ErrorStateMatcher as MaterialErrorStateMatcher } from '@angular/material/core';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { DateMaskDirective } from './directives/date-mask.directive';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ErrorStateMatcher } from './config/error-state-matcher';
import { FileUploadModule } from 'ng2-file-upload';
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { DateFormatAdapter, PICK_FORMATS } from './config/date-format-adapter';
import { PaginatorPtbr } from './config/paginator';
import { TextMaskModule } from 'angular2-text-mask';
import { ButtonsModule } from './components/buttons/buttons.module';
import { SharedFormsModule } from './forms/shared-forms.module';
import { MatButtonModule } from '@angular/material/button';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {NgxPaginationModule} from 'ngx-pagination';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
	align: 'left',
	allowNegative: true,
	decimal: ',',
	precision: 2,
	prefix: 'R$ ',
	suffix: '',
	thousands: '.'
};

const imports = [
	CommonModule,
	PerfectScrollbarModule,
	ToastrModule.forRoot({ preventDuplicates: true,}),
	NgbModule,
	SharedComponentsModule,
	SharedDirectivesModule,
	SharedPipesModule,
	RouterModule,
	
];

const exportsComponents = [
	DateMaskDirective,
	SharedFormsModule,
	CurrencyMaskModule,
	FileUploadModule,
	FormsModule,
	MatCheckboxModule,
	MatDatepickerModule,
	MatPaginatorModule,
	MatIconModule,
	MatInputModule,
	MatRadioModule,
	MatSelectModule,
	MatSlideToggleModule,
	MatTabsModule,
	MatTooltipModule,
	MatButtonModule,
	MatChipsModule,
	MatAutocompleteModule,
	NgxMatSelectSearchModule,
	NgxPaginationModule,
	NgbModule,
	ReactiveFormsModule,
	SharedComponentsModule,
	SharedDirectivesModule,
	SharedPipesModule,
	TextMaskModule,
	MatDialogModule,
	ButtonsModule
];

const providers = [
	{ provide: MaterialErrorStateMatcher, useValue: new ErrorStateMatcher() },
	{ provide: DateAdapter, useClass: DateFormatAdapter },
	{ provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
	{ provide: MatPaginatorIntl, useClass: PaginatorPtbr },
	{ provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
];

@NgModule({
	imports,
	exports: exportsComponents,
	providers,
	declarations: [DateMaskDirective]
})
export class SharedModule {}
